/* eslint-disable react/no-unused-state */
/* eslint-disable react/require-default-props */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Banner from 'yoda-core-components/lib/components/Banner/Banner';
import List from 'yoda-core-components/lib/components/List/List';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { getMediaTypeForDeviceType } from '../../../../utils';
import {
    setInteractiveVizNavInSession,
    getSelectedProgramFromFilters,
    isNotIrisInTool,
    extractTextFromHtml,
} from '../../../../helpers/Utils/interactiveVizNav';
import CustomSlider from '../CustomSlider/CustomSlider';
import RichText from '../../../RichText/RichText';
import * as styles from './InteractiveVizNav.css';

const cx = classNames.bind(styles);

export class InteractiveVizNav extends PureComponent {
    static defaultProps = {
        deviceType: {},
        vizNav: [],
        onInteractiveVizNaveSizeSelectionChange: {},
        programId: '',
        selectedFilters: [],
        disableFitFinderLeftNavFilters: false,
        softRefresh: true,
        customClass: '',
        preferences: {},
    };

    static propTypes = {
        deviceType: PropTypes.object,
        vizNav: PropTypes.array,
        onInteractiveVizNaveSizeSelectionChange: PropTypes.func,
        programId: PropTypes.string,
        softRefresh: PropTypes.bool,
        selectedFilters: PropTypes.array,
        disableFitFinderLeftNavFilters: PropTypes.bool,
        excludeQueryString: PropTypes.array.isRequired,
        isBottomToTopFilterSelection: PropTypes.bool.isRequired,
        cacheMins: PropTypes.number.isRequired,
        customClass: PropTypes.string.isRequired,
        isClearAllFilterApplied: PropTypes.bool.isRequired,
        preferences: PropTypes.object,
    };

    constructor() {
        super();
        this.state = {
            onMouseOverHeading: '',
            selectedProgram: '',
            programSelected: false,
            selectedItemIndex: 0,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        /* istanbul ignore next */
        if (
            !_isEqual(nextProps.selectedFilters, this.props.selectedFilters) ||
            !_isEqual(nextProps.vizNav, this.props.vizNav)
        ) {
            const {
                vizNav,
                isBottomToTopFilterSelection,
                programId,
                excludeQueryString,
                disableFitFinderLeftNavFilters,
                isClearAllFilterApplied,
            } = nextProps;
            const { programSelected = false } = nextState;

            const program = getSelectedProgramFromFilters(
                programId,
                vizNav,
                excludeQueryString,
                nextProps.cacheMins
            );
            this.setState({
                selectedProgram: program,
            });

            if (
                (disableFitFinderLeftNavFilters && isBottomToTopFilterSelection) ||
                (!programSelected && !program) ||
                isClearAllFilterApplied
            ) {
                this.setState({
                    selectedProgram: '',
                    programSelected: true,
                });
                setInteractiveVizNavInSession(programId, 'heading', '', nextProps.cacheMins);
            }
        }

        if (!_isEqual(nextProps.vizNav, this.props.vizNav)) {
            this.setState({ selectedItemIndex: 0 });
        }
    }

    onInteractiveVizNaveSizeSelection = (event, heading, url) => {
        event.preventDefault();
        const {
            onInteractiveVizNaveSizeSelectionChange,
            programId,
            softRefresh,
            cacheMins,
        } = this.props;
        setInteractiveVizNavInSession(programId, 'heading', heading, cacheMins);
        onInteractiveVizNaveSizeSelectionChange({ heading, callAnalytics: true });
        if (!_isEmpty(url) && isNotIrisInTool()) {
            if (softRefresh) {
                getBrowserHistory().push(url);
            } else {
                window.location.href = url;
            }
        }
    };

    mouseOver = (event, heading) => {
        event.preventDefault();
        this.setState({
            onMouseOverHeading: heading,
        });
    };

    mouseOut = () => {
        this.setState({ onMouseOverHeading: '' });
    };

    listRenderContent = (dataItem) => {
        const { onMouseOverHeading, selectedProgram } = this.state;
        const {
            deviceType,
            onInteractiveVizNaveSizeSelectionChange,
            programId,
            cacheMins,
            preferences,
        } = this.props;
        const {
            heading = '',
            link: { url: linkUrl = '' } = {},
            headingBgColor = '',
            flagTextBgColor = '',
            flagText = '',
            inspirationDetails,
        } = dataItem;
        const { url: mediaUrl = '' } = getMediaTypeForDeviceType(deviceType, dataItem);
        const alttextval = _get(inspirationDetails, 'headline', '').replace('&nbsp;', '');
        const { isDesktop } = deviceType;
        const isMouseOver = isDesktop && onMouseOverHeading === heading;
        let isSelectedVal = '';
        /* istanbul ignore next */
        const imageExt = checkUrlExtension(mediaUrl);
        const convUrl = replaceSubdomain(mediaUrl, preferences);

        if (
            selectedProgram &&
            extractTextFromHtml(selectedProgram) === extractTextFromHtml(heading)
        ) {
            isSelectedVal = heading;
            setInteractiveVizNavInSession(programId, 'heading', heading, cacheMins);
            onInteractiveVizNaveSizeSelectionChange({
                heading: isSelectedVal,
                callAnalytics: false,
            });
        }
        return (
            <button
                id={heading}
                data-automation-id="visnav-card-block"
                className={cx('renderContentContainer', { isSelected: isSelectedVal })}
                onClick={(event) => {
                    this.onInteractiveVizNaveSizeSelection(event, heading, linkUrl);
                }}
                style={{ borderColor: isSelectedVal || isMouseOver ? headingBgColor : '' }}
                onMouseOver={(event) => {
                    this.mouseOver(event, heading);
                }}
                onMouseOut={this.mouseOut}
            >
                <h3
                    data-automation-id="visnav-title"
                    className={cx('renderContentTitle')}
                    style={{ background: headingBgColor }}
                >
                    <RichText text={heading} />
                </h3>
                {imageExt === 'mp4' ? (
                    <video
                        playsInline
                        autoPlay
                        muted
                        loop
                        width="100%"
                        height="auto"
                        className={cx('rendervideomp4')}
                    >
                        <source
                            src={convUrl}
                            type="video/mp4"
                            automationId="fitfinder-modal-image"
                            altText={alttextval}
                        />
                    </video>
                ) : (
                    <div
                        data-automation-id="Visnav-Banner-image"
                        className={cx('renderContentImage')}
                    >
                        <Banner
                            automationId="fitfinder-modal-image"
                            bannerImageUrl={mediaUrl}
                            altText={alttextval}
                        />
                    </div>
                )}
                {flagText && (
                    <div
                        data-automation-id="visnav-flaglabel"
                        className={cx('renderContentLabel')}
                        style={{ background: flagTextBgColor }}
                    >
                        <RichText text={flagText} />
                    </div>
                )}
            </button>
        );
    };

    render() {
        const { deviceType, vizNav, customClass } = this.props;
        if (_isEmpty(vizNav)) {
            return null;
        }

        return (
            <div
                data-automation-id="renderContentSliderBlock"
                className={cx('renderContentSliderBlock', customClass)}
            >
                <CustomSlider
                    wrapperClass={cx('sliderVisNavWrapper')}
                    contentWrapperClass={cx('visnavContentWrapper')}
                    deviceType={deviceType}
                    customLeftButtonSliderClass={cx('fitFinderLeftButtonClass')}
                    customRightButtonSliderClass={cx('fitFinderRightButtonClass')}
                    datasource={vizNav}
                >
                    <List
                        datasource={vizNav}
                        childRenderer={this.listRenderContent}
                        automationId="render-item-content"
                        spacing="None"
                        listMainCustomClass={cx('renderListMainCustomClass')}
                        listStyleClass={cx('renderListStyle')}
                        listBodyClass={cx('renderListBody')}
                        itemStyleClass={cx('renderItemStyle')}
                        direction="Wrap"
                    />
                </CustomSlider>
            </div>
        );
    }
}

export default InteractiveVizNav;
